import { StackProps, SxProps, TypographyProps } from "@mui/material";
import muiVariables from "../../styles/mui-variables";

const EventDetailsModelStyle = {
  mainBoxStyle: {
    justifyContent: "center",
    alignItems: "center",
    padding: "8px 0px 8px 8px",
  } as SxProps,
  mainHeaderTypo: {
    color: muiVariables.mainTextColor,
    fontFamily: muiVariables.mainFontFamily,
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "normal",
    fontStyle: "normal",
    overflow: "elipsis",
  } as TypographyProps,
  headerActionsBox: {
    gap: "10px",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  } as SxProps,
  imgStyle: {
    height: "24px",
    width: "24px",
    objectFit: "cover",
    cursor: "pointer",
  } as React.CSSProperties,
  mainTitleTypo: {
    color: muiVariables.mainTextColor,
    fontFamily: muiVariables.mainFontFamily,
    fontSize: muiVariables.subHeadingFontSize,
    fontWeight: 600,
    lineHeight: "normal",
    fontStyle: "normal",
  } as TypographyProps,
  subTitleTypo: {
    color: muiVariables.subTextColor,
    fontFamily: muiVariables.mainFontFamily,
    fontSize: muiVariables.subHeadingFontSize,
    fontWeight: 500,
    lineHeight: "normal",
    fontStyle: "normal",
  } as TypographyProps,
  eventModalImgStyle: {
    borderRadius: "6px",
    width: "113px",
    height: "72px",
    objectFit: "cover",
    margin: "5px",
  } as React.CSSProperties,
  modalBtnStack: {
    mt: 4,
    direction: "row",
    spacing: 2,
    alignItems: "center",
    justifyContent: "end",
  } as StackProps,
  modalBtnCancelSx: {
    width: "fit-content",
    backgroundColor: muiVariables.primaryColor,
    borderColor: muiVariables.borderColor,
    color: muiVariables.mainTextColor,
    "&:hover": {
      borderColor: muiVariables.borderColor,
    },
  } as SxProps,
};

export default EventDetailsModelStyle;
